<ion-menu *ngIf="this.authService.passCard !== undefined" side="start" #primerMenu menuId="primerMenu"
  contentId="principal">
  <ion-header>
    <ion-toolbar>
      <ion-title>Menu</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-list class="card-background-page">
        <ion-card>
          <img class="card-avatar" src="../../../assets/imgs/WHWP_L.jpg" />
          <ion-card-header>
            <ion-card-subtitle>
              <ion-thumbnail>
                <ion-icon size="large" color="dark" name="person"></ion-icon>
              </ion-thumbnail>
            </ion-card-subtitle>
            <ion-card-title class="ion-text-capitalize" color="dark">
              <ion-label>
                {{authService.passCard.usuario}}
              </ion-label>
            </ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-list>

      <ion-item-group *ngFor="let cat of this.authService.passCard.LstCategoriasModulos; let i = index">
        <ion-item-divider (click)="toogleSection(cat.IdCategoriaModulo)"
          [ngClass]="{ 'section-cat-active': cat.opened , 'section-cat': !cat.opened }">
          <ion-icon slot="start" [name]="(cat.opened) ? 'arrow-down' : 'arrow-forward'" color="primary"></ion-icon>
          <ion-label>{{cat.strCategoriaModulo}}</ion-label>
        </ion-item-divider>
        <div class="bok" class="box" [class.opened]="cat.opened">
          <ion-item *ngFor="let child of cat.LstModulos" (click)="navigateModule(child.component)"
            [ngClass]="{ 'section-item-active': child.selected , 'section-item': !child.selected}">
            <ion-icon name="{{ child.title | iconos:authService.passCard.LstModulos }}" slot="start"></ion-icon>
            <ion-label>{{child.title}}</ion-label>
          </ion-item>
        </div>
      </ion-item-group>

      <ion-list>
        <ion-menu-toggle>

        </ion-menu-toggle>
        <ion-menu-toggle>
          <ion-item (click)="logOut()">
            <ion-icon slot="start" color="danger" name="log-out"></ion-icon>
            <ion-label>Cerrar Sesión</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-list>
  </ion-content>
</ion-menu>